import './pages/home.js';
import './styles/main.css';
